import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-link.mjs";
import { render } from "lit-html";
import { B, APP, parseYouTubeUrl } from "../../global.ts";
import { Links } from "../../../models/Links.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

//import Strings from "../../../models/Strings.json";
//const strings: any = Strings;

const hb = new URL("../../../public/hb.svg", import.meta.url).href;

export class HbLink extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private links = new Links();
    private modal: ModalInterface;

    private jewel: HTMLElement;
    private form: HTMLFormElement;
    private shareBtn: HTMLButtonElement;
    private copy: HTMLButtonElement;
    private broadcast: HTMLButtonElement;

    private url: HTMLInputElement;
    private button: HTMLButtonElement; // paste
    private submit: HTMLButtonElement;
    private clear: HTMLButtonElement;
    private image: HTMLImageElement;

    private description: HTMLTextAreaElement;
    private magic: HTMLButtonElement;
    private paste: HTMLButtonElement;
    private trash: HTMLButtonElement;

    constructor() {
        super();
        render(template(null), this);

        this.jewel = this.querySelector("#hb-link")!;
        this.form = this.querySelector("#hb-link-form")!;
        this.shareBtn = this.querySelector("#hb-link-share")!;
        this.copy = this.querySelector("#hb-link-copy")!;
        this.broadcast = this.querySelector("button[type=submit]")!;

        this.url = this.querySelector("#hb-link-url")!;
        this.button = this.querySelector("#hb-link-button")!;
        this.submit = this.querySelector("#hb-link-submit")!;
        this.clear = this.querySelector("#hb-link-clear")!;
        this.image = this.querySelector("#hb-link-image")!;

        this.description = this.querySelector("#hb-link-description")!;
        this.magic = this.querySelector("#hb-link-magic")!;
        this.paste = this.querySelector("#hb-link-paste")!;
        this.trash = this.querySelector("#hb-link-trash")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                //window.location.hash = "#";
            },
            onShow: () => {
                // need user interaction
                //if (this.stockImage.paused) this.stockImage.play();
                //if (this.aiImage.paused) this.aiImage.play();
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-link",
            override: true
        };

        this.modal = new Modal(this.jewel, modalOptions, instanceOptions);
    }

    connectedCallback() {
        this.addUrlListeners();
        this.addDescriptionListeners();

        this.form.addEventListener("submit", async (event) => {
            event.preventDefault();
            this.broadcast.disabled = true;
            this.broadcast.classList.add("opacity-50");

            await this.links.broadcast(this.getURL(), this.url.value || APP);

            this.broadcast.classList.remove("opacity-50");
            this.broadcast.disabled = false;
            alert(
                "🎉 Your B-Link has been broadcasted via email to all your followers!"
            );
        });

        this.shareBtn.addEventListener("click", this.share.bind(this));

        this.copy.addEventListener("click", async (event) => {
            await navigator.clipboard.writeText(this.getText(false));
            alert("This B-Link has been copied to your clipboard!");
        });

        this.heartbank.addAuthStateListener((user) => {
            render(template(user), this);
        });
    }

    private addUrlListeners() {
        this.url.addEventListener("keydown", (event: KeyboardEvent) => {
            if (event.key === "Enter") {
                event.preventDefault();
                this.fetchMetadata();
                //this.url.focus();
            }
        });

        this.url.addEventListener("keyup", (event: KeyboardEvent) => {
            try {
                new URL(this.url.value);
                this.submit.classList.remove("hidden");
            } catch {
                this.submit.classList.add("hidden");
            }
        });

        // paste
        this.button.addEventListener("click", async () => {
            this.url.value = await navigator.clipboard.readText();
            await this.fetchMetadata();
            //this.url.focus();
        });

        this.submit.addEventListener("click", async () => {
            await this.fetchMetadata();
            //this.description.focus();
        });

        this.clear.addEventListener("click", async () => {
            if (
                this.url.value &&
                confirm("Would you like to clear everything and start over?")
            ) {
                this.url.value = "";
                this.description.value = "";
                this.loading(false);
                this.url.focus();
            }
        });

        this.image.addEventListener("click", async () => {});
    }

    private addDescriptionListeners() {
        this.magic.addEventListener("click", () => {
            if (
                this.url.value &&
                confirm(
                    "Would you like Miss Aquarius™ AI to improve your description?"
                )
            ) {
                this.fetchMetadata();
                //this.description.focus();
            }
        });

        this.paste.addEventListener("click", async () => {
            if (
                this.description.value.trim() === "" ||
                confirm(
                    "Would you like to replace your description with the one you copied to your clipboard?"
                )
            ) {
                this.description.value = await navigator.clipboard.readText();
                this.description.focus();
            }
        });

        this.trash.addEventListener("click", () => {
            if (
                this.description.value &&
                confirm(
                    "Would you like to clear your description and start over?"
                )
            ) {
                this.description.value = "";
                this.description.focus();
            }
        });
    }

    private loading(isLoading: boolean, src = "") {
        const description = this.description.parentElement
            ?.parentElement as HTMLElement;
        if (isLoading) {
            this.image.src = hb;
            this.image.classList.remove("hidden");
            this.image.classList.add("animate-heartbeat");
            //this.description.value = "";
            description.classList.add("hidden");
        } else {
            if (src) {
                this.image.src = src;
                this.image.classList.remove("hidden");
                this.image.classList.remove("animate-heartbeat");
            } else {
                this.image.classList.add("hidden");
            }
            description.classList.remove("hidden");
        }
    }

    private async fetchMetadata() {
        try {
            const url = new URL(this.url.value);
            this.loading(true);
            if (parseYouTubeUrl(url.toString())) {
                const endpoint = `https://www.youtube.com/oembed?format=json&url=${encodeURIComponent(
                    url.toString()
                )}`;
                const res = await fetch(endpoint);
                const json = await res.json();
                //console.log(json);
                const {
                    title,
                    author_name,
                    author_url,
                    thumbnail_url,
                    thumbnail_height,
                    thumbnail_width
                } = json;

                this.description.value = title; // `${title}\n\n• ${author_name} on YouTube`;
                this.loading(false, thumbnail_url);
            } else {
                const endpoint = `https://api.microlink.io?url=${encodeURIComponent(
                    url.toString()
                )}`;
                const res = await fetch(endpoint);
                const json = await res.json();
                //console.log(json.data);
                const { lang, date, title, author, description, image } =
                    json.data;

                const description2 = description ? `${description}\n\n` : "";
                //const author2 = author ? `• ${author}: ` : "";
                const title2 = title ? `• ${title}` : "";
                const date2 = date
                    ? `\n\n${new Date(date).toFormattedString()}`
                    : "";
                this.description.value = description || ""; // description2 + title2 + date2;

                if (image) {
                    //console.log(image);
                    const { url, width, height } = image;
                    this.loading(false, url);
                } else {
                    this.loading(false);
                }
            }
        } catch {
            alert("Please enter a valid URL");
        }
    }

    // TODO: show spinner if await is too long
    async show(url: string) {
        try {
            const link = new URL(decodeURIComponent(url));
            this.url.value = link.toString();
            await this.fetchMetadata();
            //this.url.focus();
        } catch {
            // for don't show error
        } finally {
            this.modal.show();
        }
    }

    hide() {
        this.modal.hide();
    }

    private getURL() {
        return `${B}/l/${encodeURIComponent(this.url.value || APP)}`;
    }

    private getText(isShare: boolean) {
        const header = "♒️ AQUARIUS™ BROWSER\n\n";
        const footer = "❤️ Humanity Proof by HeartBank®"; //\n\n➡️ Create your own B-Link here: https://vault.333.eco/#/link

        const description = this.description.value.trim()
            ? this.description.value.trim() + "\n\n"
            : "";
        const url = isShare ? "" : this.getURL() + "\n\n";

        return description ? header + description + url + footer : url;
    }

    private async share(event: Event) {
        this.shareBtn.disabled = true;

        const shareData = {
            title: "HeartBank® Link",
            text: this.getText(true),
            url: this.getURL(),
            files: []
        };
        //console.log(shareData);

        if (navigator.canShare && navigator.canShare(shareData)) {
            try {
                await navigator.share(shareData);
                console.log("Shared successfully");
            } catch (error: any) {
                if (
                    error.name === "AbortError" ||
                    error.name === "InvalidStateError"
                ) {
                    console.warn("Sharing was cancelled:", error);
                } else {
                    console.error(error);
                }
            }
        } else {
            alert("Sorry, Web Share is not supported on this device.");
        }

        this.shareBtn.disabled = false;
    }
}
